<template>
  <div class="section-sidebar-step-content order-2 mt-0 mt-lg-20 pb-80 pb-lg-0">
    <div class="box-link-sidebar mt-10">
      <ul
        class="d-flex flex-column align-items-start px-16 py-20 bg-ffffff border-radius-8 gap-10"
      >
        <li class="w-100 d-block p-3 fs-14 bg-ffffff underline-text"
          ><a
            class="cl-0f1c21"
            href="https://grtx.jp/privacypolicy"
            target="_blank"
            >プライバシーポリシー</a
          ></li
        >
        <li class="w-100 d-block p-3 fs-14 bg-ffffff underline-text"
          ><a
            class="cl-0f1c21"
            href="https://growthpad.zendesk.com/hc/ja/articles/12546337544473-GrowhtPad-%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"
            target="_blank"
            >利用規約</a
          ></li
        >
        <li class="w-100 d-block p-3 fs-14 bg-ffffff underline-text"
          ><a
            class="cl-0f1c21"
            href="https://growthpad.zendesk.com/"
            target="_blank"
            >ヘルプ</a
          ></li
        >
        <li class="w-100 d-block p-3 fs-14 bg-ffffff cl-587987 text-right"
          >© Growth X inc.</li
        >
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator'

@Component({})
export default class SkillStepSideBar extends Vue {
  @Prop({ required: false }) skillId: number
}
</script>

<style lang="scss" scoped>
.gap-10 {
  gap: 10px;
}

.box-link-sidebar {
  margin-left: 20px;
}
</style>
